import { useAppSelector } from 'Store';

import * as selectors from '../configSlice';

export const useSelectGoogleSettings = () => useAppSelector(selectors.selectGoogleSettings);

export const useSelectSentrySettings = () => useAppSelector(selectors.selectSentrySettings);

export const useSelectFormsDefaultValuesSettings = () =>
  useAppSelector(selectors.selectFormsDefaultValuesSettings);

export const useSelectIsConfigLoading = () => useAppSelector(selectors.selectIsConfigLoading);

export const useSelectConfigLoadError = () => useAppSelector(selectors.selectConfigLoadError);

export const useSelectShouldShowExternalLoginProviders = () =>
  useAppSelector(selectors.selectShouldShowExternalLoginProviders);

export const useSelectFreshStartFormDefaultValues = () =>
  useAppSelector(selectors.selectFreshStartFormDefaultValues);
